import React from "react"
import { withRouter } from "react-router-dom"

import "./ApplicationPrint.css"

const onlyAbroad = false

const OfflinePrint = () => {
  const year = process.env.REACT_APP_YEAR
  return (
    <div className="main-container">
      <div className="kmh-doc printable">
        <div className="headerBorder">
          ΤΟ ΠΑΡΟΝ ΔΕΝ ΥΠΟΒΛΗΘΗΚΕ ΗΛΕΚΤΡΟΝΙΚΑ ΣΕ ΓΕΑ/Β1
        </div>
        <div className="title">
          ΕΝΤΥΠΟ ΑΤΟΜΙΚΩΝ ΣΤΟΙΧΕΙΩΝ - ΕΠΙΚΑΙΡΟΠΟΙΗΜΕΝΩΝ ΕΠΙΘΥΜΙΩΝ ΜΕΤΑΘΕΣΕΩΝ
          ΕΤΟΥΣ {year}
        </div>
        <div className="heading1">ΑΤΟΜΙΚΑ ΣΤΟΙΧΕΙΑ</div>
        <table>
          <thead>
            <tr>
              <th className="smallwidth">ΒΑΘΜΟΣ</th>
              <th className="smallwidth">ΕΙΔΙΚΟΤΗΤΑ</th>
              <th>ΕΠΩΝΥΜΟ</th>
              <th>ΟΝΟΜΑ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <br />
              </td>
              <td />
              <td />
              <td />
            </tr>
            <tr>
              <th style={{ height: "3px" }} />
              <th />
              <th />
              <th />
            </tr>
            <tr>
              <th>ΑΜΑ</th>
              <th>ΑΔΤ</th>
              <th>ΜΟΝΑΔΑ</th>
              <th>ΕΞΕΙΔΙΚΕΥΣΗ</th>
            </tr>
            <tr>
              <td className="center-text ">{<br />}</td>
              <td />
              <td />
              <td />
            </tr>
          </tbody>
        </table>

        {onlyAbroad === false && (
          <>
            <div className="maginTop">
              ΕΠΙΘΥΜΩ ΜΕΤΑΘΕΣΗ : <b></b>
            </div>
            <div>ΕΠΙΘΥΜΩ ΜΕΤΑΘΕΣΗ ΣΕ ΜΟΝΑΔΑ ΔΙΕΤΙΑΣ:</div>
            <div className="heading1">ΕΠΙΘΥΜΙΕΣ ΜΕΤΑΘΕΣΗΣ</div>
            <table>
              <thead>
                <tr>
                  <th />
                  <th className="max70">ΠΕΡΙΦ. ΕΝΟΤΗΤΑ</th>
                  <th className="max70">ΔΗΜΟΣ</th>
                  <th className="max70">ΛΟΓΟΣ</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className="tinywidth tableHeaderStyle">Α</th>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th className="tinywidth tableHeaderStyle">Β</th>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th className="tinywidth tableHeaderStyle">Γ</th>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div className="maginTop">
              ΑΝΑΦΟΡΑ (επιθυμία συνυπηρέτησης, ένταξη σε κοινωνικά κριτήρια) :
            </div>
          </>
        )}
        <table className="maginTop">
          <tbody>
            <tr>
              <th className="smallwidth center-text">
                ΕΠΙΘΥΜΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΕΞΩΤΕΡΙΚΟΥ
              </th>
              <td></td>
            </tr>
          </tbody>
        </table>
        {onlyAbroad === false && (
          <>
            <div className="heading1">ΕΠΙΘΥΜΙΕΣ ΘΕΣΕΩΝ ΕΥΘΥΝΗΣ</div>
            <table>
              <tbody>
                <tr>
                  <th className="tinywidth tableHeaderStyle">Α</th>
                  <td></td>
                </tr>
                <tr>
                  <th className="tinywidth tableHeaderStyle">Β</th>
                  <td></td>
                </tr>
                <tr>
                  <th className="tinywidth tableHeaderStyle">Γ</th>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </>
        )}
        <ul>
          <li>
            Έχω λάβει γνώση της αναλυτικής μοριοδότησης και της ατομικής
            καρτέλας μου και ενημερώθηκα για τις οδηγίες και τις τεθείσες
            προθεσμίες, όπως αυτές καθορίζονται στη Διαταγή Μεταθέσεων Έτους{" "}
            {year}.
          </li>
          <li>
            Πιστοποιώ ότι τα παραπάνω στοιχεία είναι αληθή και επέχουν θέση
            Υπεύθυνης Δήλωσης.
          </li>
        </ul>
        <br />
        <div className="sign">Υπογραφή</div>
      </div>
    </div>
  )
}

export default withRouter(OfflinePrint)
